import React, { useEffect } from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import './AlertMessage.css';

const AlertMessage = ({ type, message, onClose }) => {
  let duration;
  if(type === 'success'){
    duration = 2000;
  } else if(type === 'error'){
    duration = 4000;
  } else {
    duration = 1000;
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={`alert-message ${type}`}>
      {type === 'success' ? (
        <FaCheckCircle className="alert-icon" />
      ) : (
        <FaTimesCircle className="alert-icon" />
      )}
      <span>{message}</span>
    </div>
  );
};

export default AlertMessage;
